/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Component } from 'react';
import SharedStyles from '../styles';
import styles from './info-row.styles';
import colors from '../colors';

export interface ICol {
  onClick?: () => void;
  render?: () => React.ReactElement;
}

interface IProps {
  columns: ICol[];
  header?: () => React.ReactElement;
  noFill?: boolean;
  isPhoneBreak?: boolean;
}

export default class InfoRow extends Component<IProps> {
  render() {
    const { columns, header, noFill, isPhoneBreak } = this.props;

    const _header = header && header();

    return (
      <div
        css={css(
          styles.container,
          // AER-1591: only break out of parent padding when we actually have
          // a colored background to fill — otherwise the section header ends
          // up indented further left than other section titles, creating an
          // inconsistent left edge across "Performance" / "Active Alerts" /
          // "Maintenance Alerts" / "Service Records" on the mobile redesign.
          isPhoneBreak && !noFill && styles.extendContainer,
          noFill && styles.noFill
        )}
      >
        {_header}

        <div
          css={css(
            !isPhoneBreak
              ? SharedStyles.row
              : // AER-1591: switched the mobile two-column layout from
                // block + float:left to flex + wrap so (a) floats don't
                // leak into siblings (which made the "See More Sensor
                // Details" link wrap next to the cells instead of below)
                // and (b) the row clears cleanly so subsequent sections
                // render below.
                'display: flex; flex-wrap: wrap;'
          )}
        >
          {columns.map((col, i) => {
            const elem = col.render ? col.render() : null;
            const isLast = i === columns.length - 1;
            // AER-1591: on mobile we render two cells per row. A cell is in
            // the last row when its row index matches the last row's index.
            // Cells outside the last row get a border-bottom so users can
            // tell the rows apart at a glance.
            const lastRowStartIdx =
              Math.floor((columns.length - 1) / 2) * 2;
            const isInLastRow =
              isPhoneBreak && i >= lastRowStartIdx;
            return (
              <div
                onClick={col.onClick}
                css={css(
                  styles.col,
                  `width: ${isPhoneBreak ? 50 : 100 / columns.length}%;`,
                  // AER-1591: box-sizing:border-box so 50% + padding +
                  // border doesn't overflow the parent (which was making
                  // each row's icons appear to overlap the right border).
                  isPhoneBreak && 'box-sizing: border-box; overflow: hidden;',
                  isPhoneBreak &&
                    !isInLastRow &&
                    `border-bottom: 1px solid ${colors.inputBorder};`,
                  (isLast || (isPhoneBreak && i % 2 !== 0)) &&
                    `border-right: none;`,
                  col.onClick && `cursor: pointer;`
                )}
                key={i}
              >
                {elem}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
